module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.assignment) ? _c('div', {
    staticClass: "role-assignment"
  }, [_c('v-layout', {
    attrs: {
      "py-3": "",
      "pl-3": ""
    }
  }, [_c('role-card', {
    staticClass: "card mr-3",
    attrs: {
      "role": _vm.assignment.role
    },
    model: {
      value: (_vm.roleFlipped),
      callback: function($$v) {
        _vm.roleFlipped = $$v
      },
      expression: "roleFlipped"
    }
  }), _c('membership-card', {
    staticClass: "card mr-3",
    attrs: {
      "role": _vm.assignment.role
    },
    model: {
      value: (_vm.membershipFlipped),
      callback: function($$v) {
        _vm.membershipFlipped = $$v
      },
      expression: "membershipFlipped"
    }
  })], 1), (_vm.roleFlipped) ? _c('v-layout', {
    staticClass: "info px-3"
  }, [(_vm.assignment.role == 'HITLER') ? _c('div', {
    staticClass: "hitler-info"
  }, [_c('span', [_vm._v("You are Hitler")])]) : (_vm.assignment.role == 'FASCIST') ? _c('div', {
    staticClass: "fascist-info"
  }, [_c('span', [_vm._v("You are a fascist")])]) : (_vm.assignment.role == 'LIBERAL') ? _c('div', {
    staticClass: "liberal-info"
  }, [_c('span', [_vm._v("You are a liberal")])]) : _vm._e(), (_vm.hitler) ? _c('div', {
    staticClass: "known"
  }, [_c('span', [_vm._v(_vm._s(_vm.hitler.name) + " is Hitler")])]) : _vm._e(), (_vm.fascists) ? _vm._l((_vm.fascists), function(fascist) {
    return _c('div', {
      key: fascist.id,
      staticClass: "known"
    }, [_c('span', [_vm._v(_vm._s(fascist.name) + " is a fascist")])])
  }) : _vm._e()], 2) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5d67218","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.common/ui/role-assignment.vue
// module id = 348
// module chunks = 0